import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import RemovableTextInput from '../../common/controls/removableTextInput';
const JobPieceOther = props => {
  const index = props.index,
    onChange = props.onChange,
    onRemove = props.onRemove;
  const handleChange = (field, value) => onChange(index, field, value);
  const handleRemove = () => onRemove(index);
  const newProps = _objectSpread(_objectSpread({}, props), {}, {
    onChange: handleChange,
    onRemove: handleRemove
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "t-jpo-".concat(index)
  }, /*#__PURE__*/React.createElement(RemovableTextInput, newProps));
};
JobPieceOther.propTypes = {
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};
export default JobPieceOther;